import { toCanonicalCountryCode } from '../functions/country-code.js';
/**
 * Stati membri dell'Unione europea in cui può avere sede il fornitore di un
 * acquisto intracomunitario, in codice ISO 3166-1 alpha-2 (la grafia del
 * tracciato FatturaPA).
 *
 * `XI` è l'Irlanda del Nord: dopo la Brexit il protocollo le riserva un
 * prefisso IVA proprio per le cessioni di BENI, che restano
 * intracomunitarie. `IT` non c'è per costruzione — il cedente di un acquisto
 * intra-UE è per definizione di un ALTRO Stato membro.
 *
 * Fonte unica per tutto il dominio: regolarizzazione TD20 (caso
 * intracomunitario) e integrazione TD18, che la guida AdE v1.10 riserva al
 * "cedente residente in altro paese UE".
 */
export const EU_SUPPLIER_COUNTRIES = [
    'AT',
    'BE',
    'BG',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FI',
    'FR',
    'GR',
    'HR',
    'HU',
    'IE',
    'LT',
    'LU',
    'LV',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK',
    'XI',
];
/**
 * `true` se il paese è quello di un cedente di un ALTRO Stato membro UE.
 * Il confronto normalizza spazi e maiuscole perché il paese arriva
 * dall'anagrafica o dal prefisso della partita IVA, non da un enum.
 */
export function isEuSupplierCountry(country) {
    const code = toCanonicalCountryCode(country);
    return (code !== null && EU_SUPPLIER_COUNTRIES.includes(code));
}
//# sourceMappingURL=eu-countries.js.map